<div class="p-5 grid grid-cols-4 items-center gap-2" [formGroup]="platformLicenseForm">
    <span class="label-text" i18n>Description</span>
    <div class="col-span-3 flex flex-col items-stretch gap-1">
        <input
            class="input input-sm input-bordered"
            formControlName="description"
            i18n-placeholder
            placeholder="INH User License"
            [ngClass]="{ 'border-error': platformLicenseForm.get('description').invalid }"
        />
        <span
            class="text-xs text-error"
            *ngIf="platformLicenseForm.get('description').dirty && platformLicenseForm.get('description').invalid"
            i18n
            >The description is required.</span
        >
    </div>

    <span class="label-text" i18n>Name Attribute</span>
    <div class="col-span-3 flex flex-col items-stretch gap-1">
        <input
            class="input input-sm input-bordered"
            formControlName="licenseNameAttribute"
            placeholder="USER_LICENSE"
            [ngClass]="{ 'border-error': platformLicenseForm.get('licenseNameAttribute').invalid }"
        />
        <span
            class="text-xs text-error"
            *ngIf="platformLicenseForm.get('licenseNameAttribute').dirty && platformLicenseForm.get('licenseNameAttribute').invalid"
            i18n
            >The Name Attribute is required and cannot be longer than 255 characters.</span
        >
    </div>

    <span class="label-text" i18n>Pricing type</span>
    <div class="col-span-3 flex flex-col items-stretch gap-1">
        <select
            class="col-span-3 select select-sm select-bordered"
            formControlName="licensePricingType"
            [ngClass]="{ 'border-error': platformLicenseForm.get('licensePricingType').invalid }"
        >
            <option [ngValue]="null" disabled>-</option>
            <option *ngFor="let option of licensePricingTypeOptions" [ngValue]="option?.value">
                {{ option?.label }}
            </option>
        </select>
        <span
            class="text-xs text-error"
            *ngIf="platformLicenseForm.get('licensePricingType').dirty && platformLicenseForm.get('licensePricingType').invalid"
            i18n
            >The Pricing type is required.</span
        >
    </div>

    <ng-container *ngIf="showVariablePriceBy">
        <span class="label-text" i18n>Employee calculation</span>

        <div class="col-span-3 flex flex-col items-stretch gap-1">
            <select
                class="col-span-3 select select-sm select-bordered"
                formControlName="licenseVariablePriceBy"
                [ngClass]="{ 'border-error': platformLicenseForm.get('licenseVariablePriceBy').invalid }"
            >
                <option [ngValue]="null" disabled>-</option>
                <option *ngFor="let option of licenseVariablePriceByOptions" [ngValue]="option?.value">
                    {{ option?.label }}
                </option>
            </select>
            <span
                class="text-xs text-error"
                *ngIf="platformLicenseForm.get('licenseVariablePriceBy').dirty && platformLicenseForm.get('licenseVariablePriceBy').invalid"
                i18n
                >The Employee calculation method is required.</span
            >
        </div>
    </ng-container>

    <ng-container *ngIf="showEmployeeCountingType">
        <span class="label-text" i18n>Scale price calculation</span>

        <div class="col-span-3 flex flex-col items-stretch gap-1">
            <select
                class="col-span-3 select select-sm select-bordered"
                formControlName="employeeCountingType"
                [ngClass]="{ 'border-error': platformLicenseForm.get('employeeCountingType').invalid }"
            >
                <option [ngValue]="null" disabled>-</option>
                <option *ngFor="let option of employeeCountingTypeOptions" [ngValue]="option?.value">
                    {{ option?.label }}
                </option>
            </select>
            <span
                class="text-xs text-error"
                *ngIf="platformLicenseForm.get('employeeCountingType').dirty && platformLicenseForm.get('employeeCountingType').invalid"
                i18n
                >The Scale price calculation method is required.</span
            >
        </div>
    </ng-container>
</div>
